import React from 'react';
import { Button, Result, Space } from 'antd';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import Page404 from './Page404';

export const ROUTE_ERROR_TITLE = 'Something went wrong';
export const ROUTE_ERROR_TEXT = 'This page ran into a problem and could not show. Reload to try again, or go home.';

/**
 * The route error page: what the data router shows when a page throws while
 * rendering, in place of react-router's developer screen.
 *
 * It is mounted twice in src/index.js. Inside the shell, a pathless route
 * under `Layout` catches every page's error, so the rail and the context bar
 * stay and the person can simply go somewhere else. At the root it catches
 * what the shell itself (or a page outside it — print, a share link) throws;
 * there it stands alone, because the provider stack it would sit in is the
 * thing that failed. So it reads no context of the app's: antd (themed by
 * ThemeProvider, above the router) and the router, nothing else.
 *
 * Home is a plain link, not a router navigation: a full load starts the app
 * clean, which is the point after an error.
 */
export default function RouteError() {
	const error = useRouteError();
	if (isRouteErrorResponse(error) && error.status === 404) return <Page404 />;
	return (
		<Result
			status="error"
			title={ROUTE_ERROR_TITLE}
			subTitle={ROUTE_ERROR_TEXT}
			extra={(
				<Space wrap>
					<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
					<Button href="/">Go home</Button>
				</Space>
			)}
		/>
	);
}
